import { Component, Vue, Mixins, Prop, Emit } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from "@/util/SBAPI";
import { SBMailAuthenticationResponse } from '@/components/SBMailAuthentication';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { checkUser } from '@/util/ValidationCheck';
import SBText from '@/components/SBText.vue';
import SBNextBack from '@/components/SBNextBack.vue';
import SBButtonSmall from '@/components/SBButtonSmall.vue';
import SBButtonSmallGray from '@/components/SBButtonSmallGray.vue';
import SBCheckbox from '@/components/SBCheckbox.vue';
import SBUserData from '@/components/SBUserData.vue';
import SBSignUpForm from '@/components/SBSignUpForm.vue';
import SBTextbox from '@/components/SBTextbox.vue';
import SBMailAuthentication from '@/components/SBMailAuthentication.vue';
import SBSubTitle from '@/components/SBSubTitle.vue';
import SBSection from '@/components/SBSection.vue';
import SBKurukuru from '@/components/SBKurukuru.vue';

@Component({
    components: {
        SBText,
        SBNextBack,
        SBButtonSmall,
        SBButtonSmallGray,
        SBCheckbox,
        SBUserData,
        SBSignUpForm,
        SBTextbox,
        SBMailAuthentication,
        SBSubTitle,
        SBSection,
        SBKurukuru,
    },
})
export default class NewUser extends Mixins(CommonView) {
    mode: number = 0;

    user: SBAPI.User = <SBAPI.User>{};

    passConfirmation: string = "";

    error: string = "";
    redirectUrl: string = "/";
    kurukuru: boolean = false;
    term: boolean = false;
    element: HTMLElement = <HTMLElement>document.scrollingElement;

    type: string = 'edit';

    @Prop({
        type: Object,
        default: {},
    })
    reminderToNewUser!: SBMailAuthenticationResponse;

    public async created() {
        this.user = SBAPI.user();
        if (this.$route.query && this.$route.query.url && typeof this.$route.query.url === "string") {
            this.redirectUrl = this.$route.query.url;
        }

        if (this.reminderToNewUser) {
            this.user.email = this.reminderToNewUser.email;
            this.user.code = this.reminderToNewUser.code;
            this.mode = 1;
        }
    }

    @Emit("reminder")
    public reminder(val: SBMailAuthenticationResponse) {
        return val;
    }

    public ok0(val: SBMailAuthenticationResponse) {
        if (val.user) {
            this.reminder(val);
            return;
        }
        this.user.email = val.email;
        this.user.code = val.code;
        this.element.scrollTop = 0;
        this.mode = 1;
    }

    public async ok1() {
        this.error = "";
        this.element.scrollTop = 0;
        this.mode = 2;
    }

    public async ok2() {
        this.error = "";
        if (!this.term) {
            this.error = "利用規約・個人情報保護方針に同意してください。";
            this.element.scrollTop = 0;
            return;
        }

        if (this.user.password && this.passConfirmation != this.user.password) {
            this.error = "パスワードが一致しません。";
            this.mode = 1;
            this.element.scrollTop = 0;
            return;
        }

        this.kurukuru = true;
        let res = await SBAPI.UserController.postUserUsingPOST(this.user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            if (!this.langEnglish && !this.user.kana) {
                this.error = this.error + "お名前（ヨミガナ）を入力してください";
            }
            this.mode = 1;
        } else {
            this.mode = 3;
        }

        this.element.scrollTop = 0;
        await this.getUserAPI();
        this.kurukuru = false;
    }

    public back(value: number) {
        this.mode = value;
        this.element.scrollTop = 0;
    }

    public backRedirect() {
        this.$router.push(this.redirectUrl);
    }
}

